"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _loader = _interopRequireDefault(require("../Loader/loader"));

var _button = _interopRequireDefault(require("../Button/button"));

var _dismissIcon = _interopRequireDefault(require("../Icon/dismissIcon"));

var _children = require("../helpers/children");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Message(_ref) {
  var children = _ref.children,
      id = _ref.id,
      withLoader = _ref.withLoader,
      block = _ref.block,
      banner = _ref.banner,
      dismissible = _ref.dismissible,
      onDismiss = _ref.onDismiss,
      props = _objectWithoutProperties(_ref, ["children", "id", "withLoader", "block", "banner", "dismissible", "onDismiss"]);

  var hasActions = (0, _children.getFirstDirectChildOfTypes)(children, [MessageActions]) !== undefined;
  var messageClasses = ['co-message', {
    'co-message--block': block || hasActions,
    'co-message--banner': banner
  }];
  return _react.default.createElement(_styler.default, {
    classNames: messageClasses,
    modifiers: props
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      id: id,
      className: styles
    }, (0, _getNativeProps.default)(props)), withLoader ? _react.default.createElement(_loader.default, {
      inline: true,
      small: true
    }) : _react.default.createElement(_icon.default, {
      name: selectIcon(props)
    }), _react.default.createElement("div", {
      className: "co-message__content"
    }, children), dismissible ? _react.default.createElement(_dismissIcon.default, {
      onClick: onDismiss,
      ariaLabel: "Close",
      small: true
    }) : null);
  });
}

var MessageTitle = function MessageTitle(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("strong", {
    className: "co-message__title"
  }, children);
};

var MessageActions = function MessageActions(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("div", {
    className: "co-message__actions"
  }, children);
};

var selectIcon = function selectIcon(_ref4) {
  var info = _ref4.info,
      success = _ref4.success,
      warning = _ref4.warning,
      danger = _ref4.danger,
      error = _ref4.error,
      feature = _ref4.feature;

  if (success) {
    return _icon.default.CHECK_CIRCLE;
  } else if (warning) {
    return _icon.default.WARNING;
  } else if (danger || error) {
    return _icon.default.ERROR;
  } else if (feature) {
    return _icon.default.STAR_CIRCLE;
  } else {
    return _icon.default.INFO;
  }
};

function bannerProps(props, propName, componentName) {
  var bannerType = _typeof(props.banner);

  if (bannerType !== 'boolean' && bannerType !== 'undefined') {
    return new Error('Banner prop type must be boolean.');
  }

  var hasActions = (0, _children.getFirstDirectChildOfTypes)(props.children, [MessageActions]) !== undefined;

  if (props.banner && hasActions) {
    return new Error('Banner message does not support actions.');
  }

  return null;
}

function messageChildren(props, propName, componentName) {
  var childrenCount = _react.default.Children.count(props.children);

  var error = null;

  _react.default.Children.forEach(props.children, function (child, index) {
    if ((0, _compareElementType.default)(child, MessageTitle) && index !== 0) {
      error = new Error("Message.Title can only occur once and as the first child");
    }

    if ((0, _compareElementType.default)(child, MessageActions) && index !== childrenCount - 1) {
      error = new Error("Message.Actions can only occur once as the last child");
    }
  });

  return error;
}

messageChildren.isRequired = function (props, propName, componentName) {
  if (!props[propName]) {
    return new Error("".concat(propName, " in ").concat(componentName, " is required."));
  }

  return messageChildren(props, propName, componentName);
};

var exclusiveStatusProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('info', 'success', 'warning', 'danger', 'error', 'feature');
var exclusiveTypeProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('banner', 'block');
Message.defaultProps = {
  onDismiss: function onDismiss() {}
};
Message.propTypes = {
  /** {---} Sequence of: @@Message.Title@@ (optional, max: 1), @@Message.Actions@@ (optional, max: 1) */
  children: messageChildren.isRequired,
  id: _propTypes.string,
  withLoader: _propTypes.bool,
  banner: bannerProps,

  /** {string} Mutually exclusive props: @@banner@@ @@block@@ */
  block: exclusiveTypeProps,

  /** {string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  info: exclusiveStatusProps,

  /** {string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  success: exclusiveStatusProps,

  /** {string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  warning: exclusiveStatusProps,

  /** {string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  danger: exclusiveStatusProps,

  /** {string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  error: exclusiveStatusProps,

  /** {string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  feature: exclusiveStatusProps,
  small: _propTypes.bool,
  dismissible: _propTypes.bool,

  /** {func} Function to be triggered when the message is dismissed */
  onDismiss: _propTypes.func,

  /** {func} Function needed to trigger Toasters on exist callback */
  onExit: _propTypes.func
};
MessageTitle.propTypes = {
  children: _propTypes.node.isRequired
};
MessageActions.propTypes = {
  children: (0, _airbnbPropTypes.elementType)(_button.default).isRequired
};
MessageTitle.displayName = 'Message.Title';
MessageActions.displayName = 'Message.Actions';
Message.Title = MessageTitle;
Message.Actions = MessageActions;
var _default = Message;
exports.default = _default;
Message.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Message",
  "props": {
    "onDismiss": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "{func} Function to be triggered when the message is dismissed"
    },
    "children": {
      "type": {
        "name": "custom",
        "raw": "messageChildren.isRequired"
      },
      "required": false,
      "description": "{---} Sequence of: @@Message.Title@@ (optional, max: 1), @@Message.Actions@@ (optional, max: 1)"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "withLoader": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "banner": {
      "type": {
        "name": "custom",
        "raw": "bannerProps"
      },
      "required": false,
      "description": ""
    },
    "block": {
      "type": {
        "name": "custom",
        "raw": "exclusiveTypeProps"
      },
      "required": false,
      "description": "{string} Mutually exclusive props: @@banner@@ @@block@@"
    },
    "info": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "success": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "danger": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "feature": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{string} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dismissible": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onExit": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "{func} Function needed to trigger Toasters on exist callback"
    }
  }
};